import { getTrimmedUrl } from './getTrimmedUrl'
export const getCanonical = (pathname: string, baseUrl: string) => {
    const url = `${baseUrl}${getTrimmedUrl(pathname)}`
    if (url.endsWith('/')) {
        return url.slice(0, -1)
    }
    return url
}

export const getFullCanonical = (pathname: string, baseUrl: string) => {
    const params = new URLSearchParams(pathname.split('?')[1])
    const page = params.get('page')
    const newParams = page ? `?page=${page}` : ''
    return `${baseUrl}${pathname.split('?')[0]}${newParams}`
}
